import md5 from 'md5'
import base64 from 'base64-js'
import {
  TextEncoder,
  TextDecoder
} from 'text-encoding'

function strToBase64(str) {
  let uint8array = new TextEncoder('utf-8').encode(str)
  return base64.fromByteArray(uint8array)
}

function fromBase64(base64str) {
  let array = base64.toByteArray(base64str)
  return new TextDecoder('utf-8').decode(array)
}

export const encrypt = function (str) {
  return md5(str)
}

export const setStorage = function (key, obj) {
  let json = JSON.stringify(obj)
  window.localStorage.setItem(key, strToBase64(json))
}

export const getStorage = function (key) {
  let str = window.localStorage.getItem(key)
  if (!str) {
    return null
  }

  let jsonStr = fromBase64(str)
  if (jsonStr) {
    return JSON.parse(jsonStr)
  } else {
    return null
  }
}

export const clear = function () {
  window.localStorage.clear()
}

export const removeStorage = function (key) {
  window.localStorage.removeItem(key)
}

export const getTime = function (date) {
  return new Date(date).getTime() || 1
}

export const copy = (o) => {
  var output, v, key;
  output = Array.isArray(o) ? [] : {};
  for (key in o) {
    v = o[key];
    output[key] = (typeof v === "object") ? copy(v) : v;
  }
  return output;
}



export const groupBy = (array, f) => {
  var groups = {};
  array.forEach(function (o) {
    var group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}



export const fnThrottle=(method, delay, duration)=>{
  var that = this;
  var timer = this.timer;
  var begin = new Date().getTime();
  
  return function () {
    var context = that;
    var args = arguments;
    var current = new Date().getTime();
    clearTimeout(timer);
    if (current - begin >= duration) {
      method.apply(context, args);
      begin = current;
    } else {
      that.timer = setTimeout(function () {
        method.apply(context, args);
      }, delay);
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils.js